import o from "./_arrayPush.js";
import m from "./_getPrototype.js";
import e from "./_getSymbols.js";
import s from "./stubArray.js";
var a = Object.getOwnPropertySymbols, y = a ? function(r) {
  for (var t = []; r; )
    o(t, e(r)), r = m(r);
  return t;
} : s;
const f = y;
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_getSymbolsIn.js
// module id = 916
// module chunks = 67